









































































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { parseCurrency, setValue } from 'vue-currency-input'

import { Component, Emit, Model, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { ItemResourcePayload } from '@/models'

import { VueCurrencyOptions } from '@/vue-currency-input'

import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class ItemForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: ItemResourcePayload | null

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  isValid = false

  name = ''
  description: string | null = null
  maskedPrice = ''
  isAvailable = true

  @Ref()
  readonly priceInputRef?: Vue

  get price () {
    return parseCurrency(this.maskedPrice, this.priceOptions)
  }

  set price (value: number) {
    this.$nextTick(() => {
      if (this.priceInputRef) {
        const input = this.priceInputRef.$el.getElementsByTagName('input')[0]
        setValue(input, value)
      }
    })
  }

  get priceOptions () {
    return {
      ...VueCurrencyOptions,
      allowNegative: false,
      valueRange: {
        min: 0,
        max: 999.99
      }
    }
  }

  get priceRules () {
    return {
      minPrice: this.priceOptions,
      maxPrice: this.priceOptions,
      required: true
    }
  }

  @Watch('data', { immediate: true })
  onDataChange () {
    if (this.data === null) {
      this.name = ''
      this.description = null
      this.price = 0
      this.isAvailable = true
    } else {
      this.name = this.data.name
      this.description = this.data.description
      this.price = this.data.price
      this.isAvailable = this.data.available
    }
  }

  @Watch('name')
  onNameChange () {
    this.updateModel()
  }

  @Watch('description')
  onDescriptionChange () {
    if (this.description === '') {
      this.description = null
    } else {
      this.updateModel()
    }
  }

  @Watch('price')
  onPriceChange () {
    this.updateModel()
  }

  @Watch('isAvailable')
  onIsAvailableChange () {
    this.updateModel()
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  @Emit('update:isValid')
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): ItemResourcePayload {
    return {
      groupId: this.itemGroupId,
      name: this.name,
      description: this.description,
      price: this.price,
      available: this.isAvailable
    }
  }

  submit () {
    if (this.isValid) {
      this.$emit('submit')
    }
  }
}
